// eslint-disable-next-line import/prefer-default-export
export const INPUT_WIDTH = 320;
